import { Waves, Mountain } from 'lucide-react';

export const retreats = [
  {
    id: 'bali-2026',
    title: 'Bali Movement Camp',
    tagline: 'Where movement meets the island of gods.',
    location: 'Bali, Indonesia',
    date: '1st – 6th September 2026, Uluwatu, Bali',
    duration: '6 Days / 5 Nights',
    icon: Waves,
    heroImage: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1600&q=80',
    description: 'An immersive week combining intensive movement training with Balinese culture and natural beauty. Daily training sessions, mobility work, and adventure.',
    longDescription: 'Step away from the noise and immerse yourself in six days of intentional movement, deep recovery, and Balinese culture. Set against the lush landscapes of Bali, this camp is designed for anyone ready to push their edges — physically and mentally. From morning handstand drills to sunset mobility flows, every session is crafted to help you unlock new potential in your body while connecting with a like-minded community.',
    atAGlance: [
      { title: '6 Days / 5 Nights', desc: 'Immersive stay in Bali', icon: 'calendar' },
      { title: 'Breakfast Included', desc: 'Daily breakfast at the resort', icon: 'utensils' },
      { title: 'Movement Training', desc: 'Daily strength, mobility & handstand sessions', icon: 'activity' },
      { title: 'Surf Session', desc: 'Beginner-friendly, tide dependent', icon: 'map' },
      { title: 'Recovery Sessions', desc: 'Stretching, massage & breathwork', icon: 'heart' },
      { title: 'Small Group', desc: 'Intimate group size for personal attention', icon: 'users' },
      { title: 'Airport Transfer', desc: 'One-way transfer included', icon: 'plane' },
      { title: 'Community', desc: 'Fireside talks, journaling & bonding', icon: 'star' },
    ],
    yourStay: {
      title: 'Your Stay',
      text: [
        'Uluwatu, Bali. Close to the ocean, the clifftops, and everything worth exploring — but removed enough from the crowd that evenings feel genuinely peaceful.',
        'The retreat is hosted at a boutique property that gives you the best of both: easy access to Uluwatu\'s beaches, cafés, and sunset spots during the day, and a calm, unhurried space to come back to at night.',
        '40–45 minutes from Denpasar Airport. 10–15 minutes from the best beaches and day clubs in the area.',
        'On-site: three swimming pools, a yoga shala, spa, gym, restaurant, and a complimentary beach shuttle running throughout the day.',
      ],
      image: 'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/jx9iixqr_main-resort-area-s-resorts.jpg',
    },
    rooms: [
      {
        title: 'Standard Room — Twin Sharing',
        description: 'Comfortable standard rooms with two single beds, set within the tropical resort surroundings. Each room comes with air conditioning, an en-suite bathroom, and garden views.',
        image: 'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/eyhtwtm7_image.png',
        amenities: ['Air Conditioning', 'En-suite Bathroom', 'Garden View', 'Daily Housekeeping'],
      },
      {
        title: 'Standard Room — Single Occupancy',
        description: 'The same standard room for those who prefer their own space. Ideal for full rest and recovery after a day of training and surf.',
        image: 'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/tam11rrq_image.png',
        amenities: ['Air Conditioning', 'En-suite Bathroom', 'Private Space', 'Garden View'],
      },
    ],
    inclusions: [
      '5 nights accommodation (standard rooms)',
      'Daily breakfast',
      'Daily movement & training sessions',
      'Handstand & skill-specific workshops',
      'Mobility & flexibility sessions',
      'Recovery sessions (stretching, breathwork)',
      'Surf session (beginner-friendly, tide dependent)',
      'Airport transfer (one way included)',
      'Uluwatu Sunset Experience (Padang Padang Beach + Uluwatu Temple + Kecak Fire Dance at sunset)',
      'Celebration dinner (final night)',
    ],
    exclusions: [
      'Flights to and from Bali',
      'Visa fees (if applicable)',
      'Travel insurance',
      'Lunch & dinner',
      'Personal expenses & shopping',
      'Additional spa treatments',
      'Return airport transfer',
      'Activities outside the itinerary',
    ],
    itinerary: [
      { day: 'Day 1', title: 'Arrive & Settle In', details: 'Airport pickup, check-in, welcome circle, light evening stretch, and group dinner.' },
      { day: 'Day 2', title: 'Foundation & Flow', details: 'Morning movement session focusing on strength foundations, afternoon mobility work, and evening cultural exploration.' },
      { day: 'Day 3', title: 'Push Your Edges', details: 'Intensive handstand workshop, skill-specific training, afternoon recovery session, and sunset yoga.' },
      { day: 'Day 4', title: 'Adventure Day', details: 'Rice terrace trek, waterfall visit, outdoor training session in nature, community dinner.' },
      { day: 'Day 5', title: 'Deep Practice', details: 'Advanced movement drills, partner work, mobility deep-dive, farewell bonfire and sharing circle.' },
      { day: 'Day 6', title: 'Reflect & Depart', details: 'Sunrise session, closing ceremony, breakfast, and airport transfers.' },
    ],
    gallery: [
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/2hsdvuw7_Resort_Swimming_Pool_Main_uif6wr.png',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/hrcbflbv_Fitness_Centre_2_syhsr1.jpg',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/kpxaioqo_Perfect_Wave_Surf_Lessons_fpy398.jpg',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/wnboyor2_WhatsApp_Image_2026-01-21_at_1.00.47_PM_uheoec.jpg',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/jx9iixqr_main-resort-area-s-resorts.jpg',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/eyhtwtm7_image.png',
      'https://customer-assets.emergentagent.com/job_069d6dd5-2200-4cc6-81fe-4b0e1eaff528/artifacts/tam11rrq_image.png',
      'https://customer-assets.emergentagent.com/job_c64c148e-982e-4ddf-b653-a607620581cd/artifacts/ezr3e571_DSC03302%20%281%29.jpg',
      'https://customer-assets.emergentagent.com/job_c64c148e-982e-4ddf-b653-a607620581cd/artifacts/fumsxgn1_DSC02506%20%281%29.jpg',
    ],
    pricing: {
      twinSharing: { price: '₹88,000 + 5% GST', note: 'Per person, twin sharing basis' },
      singleOccupancy: { price: '₹1,10,000 + 5% GST', note: 'Per person, private room' },
      balanceDue: 'Full balance due 30 days before the retreat',
    },
  },
  {
    id: 'gulmarg-2027',
    comingSoon: true,
    title: 'The Snow Playground',
    tagline: 'A winter escape blending skiing, movement, and mountain living.',
    location: 'Gulmarg, Kashmir',
    date: '9th – 14th February 2027',
    duration: '6 Days / 5 Nights',
    icon: Mountain,
    heroImage: 'https://images.pexels.com/photos/35873485/pexels-photo-35873485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'A winter escape blending skiing, movement, and mountain living in the breathtaking snow-covered peaks of Gulmarg.',
    longDescription: 'Imagine waking up to snow-capped peaks, fresh mountain air, and six days of skiing, snowboarding, and movement training in one of India\'s most stunning winter destinations. The Snow Playground is designed for those who want to combine the thrill of winter sports with the discipline of movement practice. Whether you\'re a first-time skier or an experienced rider, this retreat offers something for everyone — plus evening firesides, hot spring recovery, and the kind of community that makes you never want to leave.',
    atAGlance: [
      { title: '6 Days / 5 Nights', desc: 'Mountain stay in Gulmarg', icon: 'calendar' },
      { title: 'Full Board', desc: 'All meals included', icon: 'utensils' },
      { title: 'Skiing & Snowboarding', desc: 'Daily sessions with instructors', icon: 'activity' },
      { title: 'Movement Training', desc: 'Indoor strength & mobility work', icon: 'dumbbell' },
      { title: 'Hot Spring Recovery', desc: 'Natural thermal springs', icon: 'heart' },
      { title: 'Small Group', desc: 'Intimate group of 15–20 people', icon: 'users' },
      { title: 'Guided Walks', desc: 'Snow treks & mountain exploration', icon: 'map' },
      { title: 'Community', desc: 'Fireside evenings & shared meals', icon: 'star' },
    ],
    yourStay: {
      title: 'Your Stay',
      text: [
        'Gulmarg, meaning "Meadow of Flowers," transforms into a winter wonderland from December to February. Nestled at 8,694 feet in the Pir Panjal range of the Western Himalayas, it\'s one of India\'s premier ski destinations.',
        'Our accommodation is located close to the gondola station, providing easy access to the slopes. The property features heated rooms, a common lounge area, and stunning mountain views from every window.',
        'After a day on the slopes and in training, you\'ll return to warm rooms, hearty Kashmiri meals, and the kind of quiet that only mountains can offer.',
      ],
      image: 'https://images.pexels.com/photos/35873485/pexels-photo-35873485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    },
    rooms: [
      {
        title: 'Mountain View Room',
        description: 'Cozy heated rooms with panoramic views of snow-capped peaks. Wake up to the most stunning sunrises over the Himalayas from the comfort of your warm bed.',
        image: 'https://images.pexels.com/photos/11403951/pexels-photo-11403951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        amenities: ['Central Heating', 'Mountain View', 'Hot Water', 'Warm Bedding'],
      },
      {
        title: 'Premium Cabin',
        description: 'Standalone wooden cabins nestled in the snow, featuring a fireplace, king-size bed, and floor-to-ceiling windows framing the Gulmarg landscape.',
        image: 'https://images.unsplash.com/photo-1765189562981-f516274704fd?w=800&q=80',
        amenities: ['Private Fireplace', 'King-size Bed', 'Panoramic Windows', 'Room Service'],
      },
    ],
    inclusions: [
      '5 nights accommodation',
      'All meals (breakfast, lunch, dinner)',
      'Daily skiing/snowboarding sessions',
      'Ski equipment rental',
      'Movement & strength training sessions',
      'Mobility & recovery sessions',
      'Hot spring visit',
      'Guided mountain walks',
      'Fireside community evenings',
      'Retreat merchandise',
    ],
    exclusions: [
      'Flights to Srinagar',
      'Airport to Gulmarg transfers',
      'Travel insurance',
      'Personal expenses & shopping',
      'Additional ski lessons beyond included sessions',
      'Activities outside the itinerary',
    ],
    itinerary: [
      { day: 'Day 1', title: 'Arrive & Acclimate', details: 'Arrive in Gulmarg, check-in, gear fitting, welcome dinner by the fireplace, and orientation.' },
      { day: 'Day 2', title: 'First Tracks', details: 'Morning ski/snowboard session for all levels, afternoon movement training, evening hot cocoa and community time.' },
      { day: 'Day 3', title: 'Mountain Movement', details: 'Advanced slopes in the morning, indoor strength workshop, guided snow walk, and fireside storytelling.' },
      { day: 'Day 4', title: 'Adventure & Recovery', details: 'Gondola ride to Kongdoori, snow trekking, afternoon hot spring recovery session, Kashmiri feast dinner.' },
      { day: 'Day 5', title: 'Push & Celebrate', details: 'Final ski session, mobility deep-dive, farewell bonfire, sharing circle under the stars.' },
      { day: 'Day 6', title: 'Reflect & Depart', details: 'Sunrise mountain views, closing ceremony, breakfast, and departures.' },
    ],
    gallery: [
      'https://images.pexels.com/photos/35873485/pexels-photo-35873485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.unsplash.com/photo-1551524559-8af4e6624178?w=800&q=80',
      'https://images.unsplash.com/photo-1605540436563-5bca919ae766?w=800&q=80',
      'https://images.unsplash.com/photo-1483921020237-2ff51e8e4b22?w=800&q=80',
      'https://images.unsplash.com/photo-1491002052546-bf38f186af56?w=800&q=80',
      'https://images.unsplash.com/photo-1517299321609-52687d1bc55a?w=800&q=80',
    ],
    pricing: {
      twinSharing: { price: 'TBA', note: 'Per person, twin sharing basis' },
      singleOccupancy: { price: 'TBA', note: 'Per person, private room' },
      deposit: 'Deposit amount to be announced',
      balanceDue: 'Full balance due 30 days before the retreat',
    },
  },
];

export function getRetreatById(id) {
  return retreats.find(r => r.id === id);
}
